<div class="body" [class.loading]="loading">

    <ng-container *ngIf="(nextcloudExplorerComponentService.displayedFiles$|async)?.length > 0; else noFiles"></ng-container>

    <ng-container *ngIf="view == NextcloudExplorerComponentView.List">

        <ng-container *ngFor="let file of (nextcloudExplorerComponentService.displayedFiles$|async); let i=index">

            <ng-container *ngIf="singleSelectionMode">
                <div *ngIf="!file.isItself" class="list-entry singleSelection" (click)="fileClick(file)" (dblclick)="fileDblClick(file)">
                    <mat-checkbox (change)="singleSelection($event, file)" [checked]="file == singleSelectionFile"
                        (click)="$event.stopPropagation()"></mat-checkbox>
                    <app-file-list-entry class="content" [file]="file" [clickable]="enableNavigation"
                        [showOptionsMenu]="showEntryOptionMenus" (emitRefresh)="refresh()"
                        (onDeleteFromNextcloud)="refresh()" [class.selected]="currentSelection === file.fileId"></app-file-list-entry>
                </div>
            </ng-container>

            <ng-container *ngIf="multipleSelectionPresetted">
                <div *ngIf="!file.isItself" class="list-entry singleSelection" (click)="fileClick(file)" (dblclick)="fileDblClick(file)">
                    <mat-checkbox (change)="multipleSelection($event, file)"
                        [checked]="multipleSelectionMap[file.fileId]" (click)="$event.stopPropagation()">
                    </mat-checkbox>
                    <app-file-list-entry class="content" [file]="file" [clickable]="enableNavigation"
                        [showOptionsMenu]="showEntryOptionMenus" (emitRefresh)="refresh()"
                        (onDeleteFromNextcloud)="refresh()" [class.selected]="currentSelection === file.fileId"></app-file-list-entry>
                </div>
            </ng-container>

            <ng-container *ngIf="!singleSelectionMode && !multipleSelectionPresetted">
                <div *ngIf="!file.isItself" class="list-entry" (click)="fileClick(file)" (dblclick)="fileDblClick(file)">
                    <app-file-list-entry class="content" [file]="file" [clickable]="enableNavigation"
                        [showOptionsMenu]="showEntryOptionMenus" (emitRefresh)="refresh()"
                        (onDeleteFromNextcloud)="refresh()" [class.selected]="currentSelection === file.fileId"></app-file-list-entry>
                </div>
            </ng-container>

        </ng-container>

    </ng-container>

    <div *ngIf="view === NextcloudExplorerComponentView.Tiles" class="grid">

        <ng-container *ngFor="let file of (nextcloudExplorerComponentService.displayedFiles$|async); let i=index">

            <ng-container *ngIf="singleSelectionMode">
                <div *ngIf="!file.isItself" class="singleSelection" [class.selected]="currentSelection === file.fileId">
                    <mat-checkbox (change)="singleSelection($event, file)" [checked]="file == singleSelectionFile"
                        (click)="$event.stopPropagation()"></mat-checkbox>
                    <app-file-tile-entry [file]="file" (click)="fileClick(file)" (dblclick)="fileDblClick(file)"></app-file-tile-entry>
                </div>
            </ng-container>

            <ng-container *ngIf="multipleSelectionPresetted">
                <div *ngIf="!file.isItself" class="singleSelection"[class.selected]="currentSelection === file.fileId">
                    <mat-checkbox (change)="multipleSelection($event, file)"
                        [checked]="multipleSelectionMap[file.fileId]" (click)="$event.stopPropagation()">
                    </mat-checkbox>
                    <app-file-tile-entry [file]="file" (click)="fileClick(file)" (dblclick)="fileDblClick(file)"></app-file-tile-entry>
                </div>
            </ng-container>

            <ng-container *ngIf="!singleSelectionMode && !multipleSelectionPresetted">
                <div *ngIf="!file.isItself" [class.selected]="currentSelection === file.fileId">
                    <app-file-tile-entry [file]="file" (click)="fileClick(file)" (dblclick)="fileDblClick(file)"></app-file-tile-entry>
                </div>
            </ng-container>

        </ng-container>

    </div>

    <div class="footer" *ngIf="nextcloudExplorerComponentService.hasMoreEntries$|async">
        <button mat-raised-button color="primary" (click)="nextcloudExplorerComponentService.loadMore()">Mehr laden</button>
        <div class="count">
            {{nextcloudExplorerComponentService.limit$|async}} von {{(nextcloudExplorerComponentService.files$|async)?.length}}
        </div>
    </div>

</div>

<ng-template #noFiles>

    <span class="no-files-hint">Keine Dateien im Verzeichnis</span>

</ng-template>
